import { render } from "./menu-bar.vue?vue&type=template&id=55cd8481"
import script from "./menu-bar.vue?vue&type=script&lang=js"
export * from "./menu-bar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__